import {
  ColorPreset,
  P,
  TypePreset,
  Box,
  JustifyContent,
  AlignItems,
  Visibility,
  PlainLink,
  FontWeight,
  HoverEffect,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { Route } from "src/common/routing";
import { isSandboxEnvironment } from "src/common/consts";
import { LinkBuilder } from "src/components/routing";
import { useSegment } from "src/technical-integrations/segment/useSegment";
import { TrackingEvent } from "src/common/trackingEvents";

const existingAccountText = isSandboxEnvironment ? (
  <Trans id="optimised-sign-up.form.login-sandbox.text">
    Already have a sandbox account?
  </Trans>
) : (
  <Trans id="optimised-sign-up.form.login.text">Already have an account?</Trans>
);

export const LoginCTA = () => {
  const { sendEvent } = useSegment();

  return (
    <Box
      width="100%"
      layout="flex"
      justifyContent={JustifyContent.End}
      alignItems={AlignItems.End}
    >
      <Visibility visible={["none", null, null, "block"]}>
        <P
          size={3}
          color={ColorPreset.TextOnLight_01}
          preset={TypePreset.Body_02}
        >
          {existingAccountText}
        </P>
      </Visibility>
      <LinkBuilder
        route={Route.SignIn}
        onClick={() => sendEvent(TrackingEvent.SIGNUP_LOGIN_CLICKED)}
      >
        {(result) => (
          <PlainLink
            {...result}
            size={[2, null, null, 3]}
            textDecoration="underline"
            effect={HoverEffect.TextDecoration}
            weight={FontWeight.SemiBold}
            css={{
              paddingLeft: "4px",
              zIndex: 2,
            }}
            color={ColorPreset.TextOnLight_01}
            preset={TypePreset.Body_01}
          >
            {" "}
            <Trans id="optimised-sign-up.form.login.link">Log in</Trans>
          </PlainLink>
        )}
      </LinkBuilder>
    </Box>
  );
};
